<template>
  <div class="filter-container">
    <div class="filter-container-header">
      <div class="filter-container-result">
        <div class="filter-container-result__title">
          Search results for "<span class="filter-container-result__keyword">{{ categoryName ?? filter.keyword }}</span>"
        </div>
      </div>
      <div
        class="category-search"
      >
        <div class="category-search__left">
          {{ categoryName ?? filter.keyword }}
        </div>
        <input
          class="category-search__input"
          v-model="categoryKeyword"
          type="text"
          placeholder="Search within category"
          @keyup.enter="onSearch"
        >
        <div
          @click="onSearch"
          class="category-search__search"
          :class="{
            'category-search__search--active': filter.keyword != '' && filter.keyword != null
          }"
        >
          <Icon name="search-l" />
        </div>
      </div>
    </div>
  </div>
  <div class="filter-controls">
    <div class="filter-controls-left">
      <div
        class="filter-item"
        :class="{
          'filter-item--active': !filter.sortMap
        }"
        @click="sortByRelevance"
      >
        Best Match
      </div>
      <div
        class="filter-item"
        :class="{
          'filter-item--active': filter.sortMap?.monthSold
        }"
        @click="sortBySales"
      >
        Bestselling
      </div>
      <div
        class="filter-item"
        :class="{
          'filter-item--active': filter.sortMap?.price
        }"
        @click="sortByPrice"
      >
        Quality
        <div class="filter-item__right">
          <Icon
            class="filter-item__icon filter-item__icon--up"
            :class="{
              'filter-item__icon--active': filter.sortMap?.price === 'asc'
            }"
            name="triangle-right-s"
          />
          <Icon
            class="filter-item__icon filter-item__icon--down"
            :class="{
              'filter-item__icon--active': filter.sortMap?.price === 'desc'
            }"
            name="triangle-right-s"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { buriedPointUtil } from '@/utils/utils'
import { useRoute } from 'vue-router'
import { useProductList } from '../../hooks/useProductList'
import { Icon } from '@/components/Icon'

const route = useRoute()
const { filter, onReset } = useProductList()
const categoryName = computed(() => route.params.category)

const categoryKeyword = ref('')

const onSearch = () => {
  filter.keyword = categoryKeyword.value
  onReset()
  /**
   * 业务埋点：网页Featured页面内搜索
   */
  buriedPointUtil({ eventId: 'PFS201' })
}

const sortByRelevance = () => {
  filter.sortMap = null
}

const sortBySales = () => {
  filter.sortMap = {
    monthSold: 'desc'
  }
}

const sortByPrice = () => {
  if (filter.sortMap?.price === 'asc') {
    filter.sortMap = {
      price: 'desc'
    }
  } else {
    filter.sortMap = {
      price: 'asc'
    }
  }
}

watch(() => filter.sortMap, (val) => {
  onReset()
})
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
